import React, { useState, useEffect } from 'react';
import { api } from "../../services/api";
import { FaStore, FaUserTie, FaPaperPlane, FaStar, FaCheckCircle, FaBullhorn } from "react-icons/fa";
import Swal from "sweetalert2";
import Menu from "../../site/Components/menu";
import Footer from '../../comum/Footer';
import './index.css';

export default function PesquisaSatisfacao() {
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
    const [querIdentificar, setQuerIdentificar] = useState(null); 

    const [form, setForm] = useState({
        loja: '', nome: '', whatsapp: '', email: '',
        notaLoja: 0, notaAtendimento: 0,
        deixouComprar: null, produtoFalta: '',
        motivoSemCompra: '', outroMotivoTexto: '',
        notaNps: -1, sugestao: ''
    });

    const filiais = ["VR - Amaral Peixoto", "VR - São Lucas", "VR - Aterrado", "VR - Retiro - Antonio de Almeira", "VR - Retiro - Savio Gama", "VR - Vila Santa Cecilia", "Pinheiral", "Barra Mansa", "Resende", "Valença"];

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 600);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const formatPhone = (v) => {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
        v = v.replace(/(\d{5})(\d)/, "$1-$2");
        return v.substring(0, 15);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: name === 'whatsapp' ? formatPhone(value) : value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.loja || form.notaLoja === 0 || form.notaNps === -1) {
            Swal.fire("Atenção", "Por favor, preencha as avaliações de nota e filial.", "warning");
            return;
        }
        setLoading(true);
        try {
            await api.post('/pesquisa-satisfacao', form);
            Swal.fire("Sucesso!", "Obrigado por sua participação!", "success").then(() => window.location.reload());
        } catch (err) {
            Swal.fire("Erro", "Falha ao enviar pesquisa.", "error");
        } finally {
            setLoading(false);
        }
    };

    // Componente de Estrelas Centralizado
    const StarRating = ({ label, name, value }) => (
        <div style={{ marginBottom: '25px', textAlign: 'center' }}>
            <label style={labelBold}>{label}</label>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '10px' }}>
                {[1, 2, 3, 4, 5].map(s => (
                    <FaStar 
                        key={s} 
                        size={isMobile ? 40 : 35} 
                        color={s <= value ? "#ffc107" : "#e4e5e9"} 
                        style={{ cursor: 'pointer', transition: 'transform 0.1s' }} 
                        onClick={() => setForm(p => ({ ...p, [name]: s }))} 
                    />
                ))}
            </div>
        </div>
    );

    return (
        <div className="pg" style={{ background: '#f4f4f9', minHeight: '100vh' }}>
            <Menu modulo="Pesquisa" />
            <div style={{ padding: isMobile ? '10px' : '40px 20px', display: 'flex', justifyContent: 'center' }}>
                <div style={{ background: 'white', padding: isMobile ? '25px 15px' : '35px', borderRadius: '15px', width: '100%', maxWidth: '600px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                    
                    <form onSubmit={handleSubmit}>
                        <h4 style={sectionTitle}><FaStore /> Filial visitada</h4>
                        <select name="loja" value={form.loja} onChange={handleChange} style={inputStyle} required>
                            <option value="">Selecione a loja...</option>
                            {filiais.map(f => <option key={f} value={f}>{f}</option>)}
                        </select>

                        <h4 style={sectionTitle}><FaUserTie /> Identificação</h4>
                        <p style={{ ...labelBold, textAlign: 'center' }}>Deseja se identificar?</p>
                        <div style={btnGroup}>
                            <button type="button" onClick={() => setQuerIdentificar(true)} style={querIdentificar === true ? btnActive : btnInactive}>SIM</button>
                            <button type="button" onClick={() => setQuerIdentificar(false)} style={querIdentificar === false ? btnActive : btnInactive}>NÃO</button>
                        </div>

                        {querIdentificar && (
                            <div style={cardFade}>
                                <input name="nome" placeholder="Seu Nome" style={{ ...inputStyle, marginBottom: '10px' }} onChange={handleChange} />
                                <div style={{ display: 'flex', gap: '10px', flexDirection: isMobile ? 'column' : 'row' }}>
                                    <input name="whatsapp" placeholder="WhatsApp" style={inputStyle} value={form.whatsapp} onChange={handleChange} />
                                    <input name="email" placeholder="E-mail" style={inputStyle} onChange={handleChange} />
                                </div>
                            </div>
                        )}

                        <h4 style={sectionTitle}><FaCheckCircle /> Avaliação</h4>
                        <StarRating label="Como avalia a LOJA?" name="notaLoja" value={form.notaLoja} />
                        <StarRating label="Como avalia o ATENDIMENTO?" name="notaAtendimento" value={form.notaAtendimento} />

                        <h4 style={sectionTitle}>Sobre sua compra</h4>
                        <p style={{ ...labelBold, textAlign: 'center' }}>Deixou de comprar algum produto?</p>
                        <div style={btnGroup}>
                            <button type="button" onClick={() => setForm(p => ({ ...p, deixouComprar: true }))} style={form.deixouComprar === true ? btnActive : btnInactive}>SIM</button>
                            <button type="button" onClick={() => setForm(p => ({ ...p, deixouComprar: false }))} style={form.deixouComprar === false ? btnActive : btnInactive}>NÃO</button>
                        </div>

                        {form.deixouComprar && (
                            <div style={cardFade}>
                                <label style={labelMini}>Qual produto faltou?</label>
                                <input name="produtoFalta" style={{ ...inputStyle, marginBottom: '15px' }} onChange={handleChange} />
                                <p style={labelBold}>Qual o motivo?</p>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                    {["Preço mais caro", "Não encontrei o sabor", "A qualidade está ruim", "O atendimento foi ruim", "Outro motivo"].map(m => (
                                        <label key={m} style={radioLabel}>
                                            <input type="radio" name="motivoSemCompra" value={m} checked={form.motivoSemCompra === m} onChange={handleChange} /> {m}
                                        </label>
                                    ))}
                                </div>
                                {form.motivoSemCompra === "Outro motivo" && (
                                    <textarea name="outroMotivoTexto" placeholder="Favor detalhar o motivo" style={{ ...inputStyle, height: '70px', marginTop: '12px' }} onChange={handleChange} maxLength={45} />
                                )}
                            </div>
                        )}

                        <h4 style={sectionTitle}><FaBullhorn /> Pergunta Final</h4>
                        <p style={{ ...labelBold, textAlign: 'center' }}>De 0 a 10, quanto você indicaria o <b>Floresta Supermarket</b> para outra pessoa?</p>
                        <div style={npsContainer}>
                            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => (
                                <div 
                                    key={n} 
                                    onClick={() => setForm(p => ({ ...p, notaNps: n }))} 
                                    style={{ 
                                        ...npsBox, 
                                        background: form.notaNps === n ? '#27ae60' : 'white', 
                                        color: form.notaNps === n ? 'white' : '#333',
                                        border: form.notaNps === n ? '1px solid #27ae60' : '1px solid #ddd' 
                                    }}
                                >
                                    {n}
                                </div>
                            ))}
                        </div>

                        <label style={{ ...labelBold, marginTop: '30px', display: 'block' }}>Sugestões:</label>
                        <textarea name="sugestao" style={{ ...inputStyle, height: '100px' }} value={form.sugestao} onChange={handleChange} />

                        <button type="submit" disabled={loading} style={btnSubmit}>
                            <FaPaperPlane /> {loading ? 'Enviando...' : 'Finalizar Pesquisa'}
                        </button>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
}

// ESTILOS CORRIGIDOS E CENTRALIZADOS
const sectionTitle = { 
    color: '#27ae60', 
    borderBottom: '2px solid #e8f5e9', 
    paddingBottom: '8px', 
    marginTop: '35px', 
    marginBottom: '20px', 
    display: 'flex', 
    alignItems: 'center', 
    gap: '10px',
    fontSize: '1.1rem' 
};

const labelBold = { fontWeight: 'bold', color: '#34495e', marginBottom: '8px', display: 'block' };
const labelMini = { fontSize: '0.8rem', color: '#7f8c8d', marginBottom: '5px', display: 'block' };
const inputStyle = { padding: '12px', border: '1px solid #ddd', borderRadius: '8px', width: '100%', boxSizing: 'border-box', fontSize: '16px' };
const btnGroup = { display: 'flex', gap: '10px', marginBottom: '20px' };

const btnInactive = { 
    flex: 1, 
    padding: '12px', 
    border: '1px solid #ddd', 
    background: '#fff', 
    color: '#333',
    borderRadius: '8px', 
    cursor: 'pointer', 
    fontWeight: 'bold',
    fontSize: '14px'
};

const btnActive = { 
    ...btnInactive, 
    background: '#27ae60', 
    color: 'white', 
    border: '1px solid #27ae60' 
};

const cardFade = { background: '#f9f9f9', padding: '15px', borderRadius: '10px', border: '1px solid #eee', marginBottom: '20px' };
const radioLabel = { display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer', fontSize: '1rem', padding: '5px 0' };

const npsContainer = { 
    display: 'flex', 
    flexWrap: 'wrap', 
    gap: '8px', 
    justifyContent: 'center',
    marginTop: '15px' 
};

const npsBox = { 
    width: '42px', 
    height: '42px', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    cursor: 'pointer', 
    borderRadius: '8px', 
    fontWeight: 'bold',
    fontSize: '14px',
    transition: 'all 0.2s ease'
};

const btnSubmit = { 
    width: '100%', 
    padding: '16px', 
    background: '#27ae60', 
    color: 'white', 
    border: 'none', 
    borderRadius: '8px', 
    fontWeight: 'bold', 
    fontSize: '1.1rem', 
    marginTop: '30px', 
    cursor: 'pointer', 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    gap: '10px',
    boxShadow: '0 4px 6px rgba(39, 174, 96, 0.2)'
};